<div
        style="
    background-color: #737373;
    height: auto;
    width: 80%;
    margin-left: 10%;
    margin-right: 7%;
    margin-top: 2.5%;
  "
>
    <p-carousel
            [autoplayInterval]="7000"
            [circular]="false"
            [numScroll]="1"
            [numVisible]="1"
            [responsiveOptions]="responsiveOptions"
            [value]="news"
            dir="ltr"
            styleClass="custom-carousel"
    >
        <ng-template let-card pTemplate="item">
            <div style="background-color: #737373; width: 100%">
                <div class="card-item-content">
                    <div></div>
                    <div>
                        <h4
                                class="p-mb-1"
                                style="
                font-weight: bold;
                font-size: 27px;
                text-align: center;
                color: white;
                padding-top: 1%;
              "
                                translate
                        >
                            {{ card.title }}
                        </h4>
                        <div style="margin-left: 20%; margin-right: 20%; padding-top: 0.3%">
              <span
                      *ngIf="card.modDt"
                      style="
                  color: rgb(214, 208, 208);
                  font-size: 14px;
                  text-align: center;
                  margin-left: 43%;
                  margin-right: 40%;
                "
                      translate
              >Le {{ card.modDt | date: "dd/MM/yyyy" }}</span
              >
                            <br/>
                            <p
                                    [innerHtml]="card.cont1"
                                    class="st-font"
                                    style="
                  color: white;
                  font-size: 20px;
                  height: 30%;
                  margin-top: 3%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 6;
                  -webkit-box-orient: vertical;
                "
                                    translate
                            ></p>
                            <!-- <span style=" color: white; font-size: 20px;" [innerHtml]="card.cont1" translate></span> -->
                        </div>
                        <br/>

                        <div
                                style="text-align: center; margin-bottom: 1.9%; margin-top: -2.5%"
                        >
                            <button
                                    (click)="voirannonces()"
                                    class="voir"
                                    mat-flat-button
                                    translate
                            >
                                {{ "Voir toutes les annonces" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>
